export default __webpack_public_path__ + "locales/tr/DataReassignmentDialog.json?hash=c766f015abe0785bf6df71836e7e8179";